import React, {Component} from "react";
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {StateWrapper} from '../form-validator';

// Simple radio field. Value is value selected
// List of acceptable values is in the radioList property
// For now we only support checkbox with labels, not yet inline
class CheckboxField extends Component {
    render() {
        const {name, description, descriptionSuffix, mode, className, labelClass, inputClass, disabled, 
            // extract validations so it does not go into rest
            validations,
            // these values are injected by StateWrapper
            value, onChange, onBlur, validationState, ...rest} = this.props,
            {status, messages} = validationState || {},
            hasError = status === 'error' && Array.isArray(messages);

        if (mode === 'none') {
            return (
                <React.Fragment>
                    <input type="checkbox"
                           name={name}
                           id={name}
                           className={classNames(inputClass, {'is-invalid': hasError})}
                           checked={!!value}
                           value="true"
                           onChange={onChange}
                           onBlur={onBlur}
                           aria-describedby={"sr-" + name}
                           aria-invalid={hasError}
                           {...rest}
                    />
                    <label htmlFor={name} className={labelClass}>
                        {description}
                    </label>
                    <div key={"sr-" + name} id={"sr-" + name} className={classNames("error-message", {'invalid-feedback': hasError})}
                         aria-live="assertive" aria-hidden={hasError ? 'false' : 'true'}>
                        {
                            hasError && messages.map(
                                item => (
                                    <div key={item}>
                                        {item}
                                    </div>
                                ))
                        }
                    </div>
                </React.Fragment>
            );
        }
        return (
            <div className={className}>
                <input type="checkbox"
                       name={name}
                       id={name}
                       className={classNames(inputClass, {'is-invalid': hasError})}
                       checked={!!value}
                       disabled={!!disabled}
                       onChange={onChange}
                       onBlur={onBlur}
                       aria-describedby={"sr-" + name}
                       aria-invalid={hasError}
                       {...rest}
                />
                <label htmlFor={name} className={labelClass}>
                    {description} {descriptionSuffix ? descriptionSuffix : ''}
                </label>
                <div key={"sr-" + name} id={"sr-" + name} className={classNames("error-message", {'invalid-feedback': hasError})}
                     aria-live="assertive" aria-hidden={hasError ? 'false' : 'true'}>
                    {
                        hasError && messages.map(
                            item => (
                                <div key={item}>
                                    {item}
                                </div>
                            ))
                    }
                </div>
            </div>
        );
    }
}

CheckboxField.propTypes = {
    name: PropTypes.string.isRequired,
    type: PropTypes.string,
    description: PropTypes.string,
    value: PropTypes.bool,
    onChange: PropTypes.func.isRequired
};

export default StateWrapper(CheckboxField);